import React from "react";
import DateTimePicker from "react-datetime-picker";

// Import all required CSS files for react-datetime-picker
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

/**
 * Wrapper component for react-datetime-picker that includes all required CSS imports.
 * 
 * This component ensures that all necessary styles are loaded when DateTimePicker is used,
 * eliminating the need to import CSS files in every component that uses it.
 * 
 * Usage:
 * ```jsx
 * import DateTimePicker from "components/DateTimePicker/DateTimePicker";
 * 
 * <DateTimePicker
 *   onChange={handleChange}
 *   value={selectedDate}
 *   disabled={false}
 * />
 * ```
 * 
 * All props are forwarded to the underlying react-datetime-picker component.
 * See https://github.com/wojtekmaj/react-datetime-picker for full API documentation.
 */
const DateTimePickerWrapper = React.forwardRef((props, ref) => {
  return <DateTimePicker ref={ref} {...props} />;
});

DateTimePickerWrapper.displayName = "DateTimePicker";

export default DateTimePickerWrapper;
